import { CCPOfferingContent } from 'src/contentful/product-catalog';

import {
	CloudOfferingKey,
	CloudProductKey,
	OfferingHamsMap,
	OfferingSKUMap,
	PricingPeriod,
	PricingPlans,
	PricingTier,
	ProductOffering,
} from '../constants';

import { convertCCPPricingPlansToHAMS, GetCcpTiers } from './ccp-to-hams-pricing-plan-converter';

export type { GetCcpTiers };

export const extractPricingTiersFromEntry = (
	ccpOfferingsBySKU: OfferingSKUMap<CloudOfferingKey, CCPOfferingContent>,
	hamsPricingPlansByKey: OfferingHamsMap<CloudProductKey, PricingPlans>,
	period: PricingPeriod,
	currencyISOCode: string,
	ccpOfferingSKU?: ProductOffering<CloudOfferingKey>,
	hamsProductKey?: CloudProductKey,
	getCcpTiers?: GetCcpTiers,
): PricingTier[] | undefined => {
	let pricingPlans;

	let pricingTiers: PricingTier[];

	if (ccpOfferingSKU) {
		const offering = ccpOfferingsBySKU[ccpOfferingSKU];

		pricingPlans = offering?.defaultPricingPlans;
		if (!pricingPlans) {
			console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
			return undefined;
		}

		const convertedTiers = convertCCPPricingPlansToHAMS(pricingPlans, currencyISOCode, getCcpTiers);
		if (period === 'MONTHLY' && convertedTiers.monthly) {
			pricingTiers = convertedTiers.monthly.slice();
		} else if (period === 'ANNUAL' && convertedTiers.annual) {
			pricingTiers = convertedTiers.annual.slice();
		} else {
			console.log(
				`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`,
			);
			return undefined;
		}
	} else {
		if (hamsProductKey === undefined) {
			console.log(`HAMS product key was undefined for price request!`);
			return undefined;
		}
		pricingPlans = hamsPricingPlansByKey[hamsProductKey];
		if (pricingPlans === undefined) {
			console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
			return undefined;
		}

		if (period === 'MONTHLY' && pricingPlans.monthly) {
			pricingTiers = pricingPlans.monthly.slice();
		} else if (period === 'ANNUAL' && pricingPlans.annual) {
			pricingTiers = pricingPlans.annual.slice();
		} else {
			console.log(
				`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`,
			);
			return undefined;
		}
	}

	return pricingTiers;
};
